// Pure helpers behind Lead QA Review's hide-filters, Notes dropdown and note
// bylines (2026-10-20, PM request). Kept out of LeadQA.js so they can be tested.
// Backend half: leads.qa_override_note_by / _at (migration 0125).

// ---------------------------------------------------------------------------
// Column filter text: plain text keeps rows containing it (as before); text
// starting with "!" HIDES rows containing it ("!sl" hides every row with "sl").
// A bare "!" filters nothing yet.
// ---------------------------------------------------------------------------
export function matchesColFilter(cellValue, filterText) {
  if (!filterText) return true;
  const cell = String(cellValue || '').toLowerCase();
  if (filterText.charAt(0) === '!') {
    const needle = filterText.slice(1).trim().toLowerCase();
    return !needle || !cell.includes(needle);
  }
  return cell.includes(filterText.toLowerCase());
}

// Notes dropdown: who left the review note on a lead. Authors are recorded by
// the server (qa_override_note_by); notes written before that existed have no
// author, so they count as "a note" but are never "mine" or "someone else's".
export const NOTE_FILTER_OPTIONS = [
  { value: 'any',      label: 'All leads' },
  { value: 'with',     label: 'With a note' },
  { value: 'without',  label: 'Without a note' },
  { value: 'mine',     label: 'I left a note' },
  { value: 'not_mine', label: "I haven't left a note" },
  { value: 'others',   label: 'Someone else left a note' },
];

export function matchesNoteFilter(lead, mode, myId) {
  const hasNote = !!(lead.qa_override_note && String(lead.qa_override_note).trim());
  const by = lead.qa_override_note_by;
  switch (mode) {
    case 'with':     return hasNote;
    case 'without':  return !hasNote;
    case 'mine':     return hasNote && by != null && by === myId;
    case 'not_mine': return !(hasNote && by != null && by === myId);
    case 'others':   return hasNote && by != null && by !== myId;
    default:         return true;
  }
}

// "Sarah Lee" -> "SL" (first letters of up to two words).
export function noteInitials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  return parts.slice(0, 2).map(w => w.charAt(0).toUpperCase()).join('');
}

// Backend timestamps are UTC without a Z (see top-level CLAUDE.md), shown in New York time.
export function noteDate(iso) {
  if (!iso) return '';
  const d = new Date(String(iso).endsWith('Z') ? iso : `${iso}Z`);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'America/New_York' });
}

// "SL · Oct 20 — " in front of a note whose author the server recorded; '' for older notes.
export function noteByline(lead) {
  if (!lead.qa_override_note_by_name) return '';
  const when = noteDate(lead.qa_override_note_at);
  return `${noteInitials(lead.qa_override_note_by_name)}${when ? ` · ${when}` : ''} — `;
}
